import React from 'react';

import MetricBox from './MetricBox';

interface FlightTimeToRTHProps {
  timeRemainingSec: number;
  timeToHomeSec: number;
}

const format = (seconds: number): string => {
  const m = Math.floor(seconds / 60)
    .toString()
    .padStart(2, '0');
  const s = Math.floor(seconds % 60)
    .toString()
    .padStart(2, '0');
  return `${m}:${s}`;
};

const FlightTimeToRTH: React.FC<FlightTimeToRTHProps> = ({ timeRemainingSec, timeToHomeSec }) => {
  const diff = Math.max(timeRemainingSec - timeToHomeSec, 0);
  return <MetricBox label='Flight Time to RTH' value={format(diff)} />;
};

export default FlightTimeToRTH;
